import "./index.css"
import { UiController } from "./UI/UiController";

new UiController();